import { useEpocusAdminProgramsQuery } from "./__generated__/epocus-admin-operations.gql";

export const useAdminProgram = (programId: string | undefined) => {
  const { data, loading, error } = useEpocusAdminProgramsQuery();
  const program = data?.epocusPrograms.find((p) => p.id === programId);

  return {
    program,
    loading: loading && !data,
    error,
    notFound: !loading && !error && !program,
  };
};
